import React from "react";
import styled from "styled-components";
import withTheme from "../hoc/withTheme";
import LogoItem from "./headerItems/logo.header";
import PageItem from "./headerItems/PageItem";
import ThemeButton from "./headerItems/themebutton";
import withLocalization from "../hoc/withLocalization";
import { LEFT_TO_RIGHT } from "../state/actions/localization.action";
import LocalButton from "./headerItems/LocalButton";

const Header = props => {
  const { theme, i18n } = props;
  return (
    <Container theme={theme} i18n={i18n}>
      <Left i18n={i18n}>
        <LogoItem />
        <PageItem active>{i18n.header.home}</PageItem>
        <PageItem>{i18n.header.islamic}</PageItem>
        <PageItem>{i18n.header.documentary}</PageItem>
        <PageItem>{i18n.header.kids}</PageItem>
      </Left>
      <Right i18n={i18n}>
        <ThemeButton />
        <LocalButton />
      </Right>
    </Container>
  );
};

const Container = styled.div`
  color: ${props => props.theme.colors.background.text};
  display: flex;
  flex-direction: ${props =>
    props.i18n.dir === LEFT_TO_RIGHT ? "row" : "row-reverse"};
  justify-content: space-around;
  align-items: center;
  padding: 20px 0px;
`;
const Left = styled.div`
  display: flex;
  flex-direction: ${props =>
    props.i18n.dir === LEFT_TO_RIGHT ? "row" : "row-reverse"};
  justify-content: flex-start;
  align-items: center;
`;
const Right = styled.div`
  display: flex;
  flex-direction: ${props =>
    props.i18n.dir === LEFT_TO_RIGHT ? "row" : "row-reverse"};
  justify-content: flex-end;
  align-items: center;
`;

export default withLocalization(withTheme(Header));
